"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  selectedSeries: 0
};

export { defaultOptions, pluginVersion };
